import { MathUtils, Rect } from '@printu/geom';
import { getItemBounds } from 'app/core/markers/bounds';
// import type { PageItem, UID } from '@printu/models';
// import { getItemRect } from '@printu/models';
// import type { NormalizedPage } from 'app/core/store/states/project';
// import type { ProjectState } from 'app/core/store/states/root';
const getNextSortIndex = (index, dir) => {
    switch (dir) {
        case 'up':
            return index + 1;
        case 'down':
            return index - 1;
        default:
            return index;
    }
};
function swap(array, indexA, indexB) {
    const tmp = array[indexB];
    array[indexB] = array[indexA];
    array[indexA] = tmp;
}
export function pageItemsReorderReducer(collection, items, dir) {
    if (!items || !items.length) {
        return undefined;
    }
    const ids = new Set(items.map(item => item.id));
    let sortedItems = items
        .map(item => ({
        item,
        index: collection.indexOf(item),
    }))
        .sort((itemA, itemB) => itemA.index - itemB.index);
    // filter items not important for current reordering direction
    let depthFilter;
    switch (dir) {
        case 'up':
            sortedItems = sortedItems.reverse();
            depthFilter = (refItemIndex, itemIndex) => itemIndex > refItemIndex;
            break;
        case 'down':
            depthFilter = (refItemIndex, itemIndex) => itemIndex < refItemIndex;
            break;
        default:
            return undefined;
    }
    // most important item from reordering direction pov
    const { item: refItem, index: refItemIndex } = sortedItems[0];
    const refItemEdges = getItemBounds(refItem).toRect().getEdges();
    const availableReorderIndices = collection
        .map((item, index) => ({
        item,
        index,
    }))
        // skip those to rearrange
        .filter(entry => !ids.has(entry.item.id))
        // filterout those not important for reordering direction
        .filter(entry => depthFilter(refItemIndex, entry.index))
        // get element edges
        .map(entry => (Object.assign(Object.assign({}, entry), { edges: getItemBounds(entry.item).toRect().getEdges() })))
        // filter those not colliding with ref item
        .filter(entry => Rect.edgesCollide(refItemEdges, entry.edges))
        // get possible reorder indices
        .map(entry => entry.index);
    if (!availableReorderIndices.length) {
        return undefined;
    }
    let reorderIndex;
    switch (dir) {
        case 'up':
            // eslint-disable-next-line prefer-destructuring
            reorderIndex = availableReorderIndices[0];
            break;
        case 'down':
            reorderIndex =
                availableReorderIndices[availableReorderIndices.length - 1];
            break;
        default:
            return undefined;
    }
    const nextRefIndex = MathUtils.clamp(reorderIndex, 0, collection.length - 1);
    if (nextRefIndex === refItemIndex) {
        return undefined;
    }
    const newItems = [...collection];
    const reorderSteps = Math.abs(nextRefIndex - refItemIndex);
    let reorderStep = 0;
    while (reorderStep < reorderSteps) {
        reorderStep += 1;
        sortedItems.forEach(entry => {
            const nextIndex = getNextSortIndex(entry.index, dir);
            swap(newItems, entry.index, nextIndex);
            entry.index = nextIndex;
        });
    }
    return newItems.map(item => item.id);
}
